import React, { useState, useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './Experience.module.css';
import ExperienceListCategories from './components/ExperienceListCategories';
import ExperienceCard from './components/ExperienceCard';
import { useDeviceSize } from './hooks/useDeviceSize';
import { showFavoriteListing } from '../../../ListingPage/ListingPage.duck';
import ExperiencesListSkeleton from '../Skeletons/ExperiencesListSkeleton';
import { connect } from 'react-redux';
import { formatListing } from './utils/formating';
import { useParams } from 'react-router-dom';

const ExperienceListComponent = ({
  subHeader,
  ids,
  categoryData,
  onFetchListing,
  categoryTab,
  slice,
}) => {
  const [selectedCategory, setSelectedCategory] = useState(() =>
    categoryTab === 'experiences' ? 'popular' : 'stays'
  );
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { isMobileDevice } = useDeviceSize();
  const { lang: currentLanguage } = useParams();

  const getDisplayedName = useCallback(
    item => {
      const nameToUse = currentLanguage === 'de' && item?.name_de ? item?.name_de : item?.name;
      return nameToUse?.split(' • ')[0] ?? nameToUse ?? '';
    },
    [currentLanguage]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setError(null);
        let filteredIds = [];
        if (!selectedCategory) return;

        const locationCategories =
          categoryTab === 'experiences'
            ? ['europe']
            : [
                'europe',
                'asia',
                'south-america',
                'italy',
                'spain',
                'colombia',
                'indonesia',
                'ecuador',
                'namibia',
              ];

        if (locationCategories.includes(selectedCategory)) {
          filteredIds = ids.filter(id => id.location === selectedCategory);
        } else {
          filteredIds = ids.filter(id => id.projectType?.includes(selectedCategory));
        }

        if (filteredIds.length === 0) {
          setData([]);
          setIsLoading(false);
          return;
        }

        const data = await Promise.all(
          filteredIds.map(filteredId =>
            onFetchListing(filteredId.id).then(({ data }) => formatListing(data, currentLanguage))
          )
        );

        setData(data);
      } catch (err) {
        setError(err.message);
        console.error('error in listing fetch and format :', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [currentLanguage, selectedCategory, ids, categoryTab]);

  return (
    <div className={styles.outerWrapper} data-elbaction="visible:vis lp-inspo-section">
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>
          {subHeader ? <FormattedMessage id={subHeader} /> : ''}
        </h2>
        <ExperienceListCategories
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          isMobileDevice={isMobileDevice}
          categoryData={categoryData}
          categoryTab={categoryTab}
        />
        <div className={styles.AllCards}>
          {isLoading ? (
            <ExperiencesListSkeleton />
          ) : error ? null : (
            <>
              {(slice ? data.slice(0, slice) : data).map((item, index) => (
                <ExperienceCard
                  key={item.id || index}
                  item={item}
                  shortName={getDisplayedName(item)}
                  currentLanguage={currentLanguage}
                />
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  onFetchListing: listingId =>
    dispatch(showFavoriteListing(listingId, { layout: { listingImage: {} } })),
});

export const ExperienceList = connect(null, mapDispatchToProps)(ExperienceListComponent);

export default ExperienceList;
